import React from 'react';
import { BehaviorSubject, Observable } from 'rxjs';
import { GuslUser, SessionStatus, User } from 'src/providers/session/types';

export interface SessionState {
  loginSubject: BehaviorSubject<GuslUser | null>;
  systemReadySubject: BehaviorSubject<boolean>;
  sessionStatusSubject: BehaviorSubject<SessionStatus>;
  watchLogin: () => Observable<GuslUser | null>;
  watchSystemReady: () => Observable<boolean>;
  watchSessionStatus: () => Observable<SessionStatus>;
  getLoggedInUser: () => User;
}

export function useSessionState(): SessionState {
  const [loginSubject] = React.useState(() => new BehaviorSubject<GuslUser | null>(null));
  const [systemReadySubject] = React.useState(() => new BehaviorSubject<boolean>(false));
  const [sessionStatusSubject] = React.useState(
    () => new BehaviorSubject<SessionStatus>(SessionStatus.LOADING),
  );

  const watchLogin = (): Observable<GuslUser | null> => loginSubject.asObservable();
  const watchSystemReady = (): Observable<boolean> => systemReadySubject.asObservable();
  const watchSessionStatus = (): Observable<SessionStatus> => sessionStatusSubject.asObservable();

  const getLoggedInUser = (): User => {
    const user = loginSubject.getValue();
    return user
      ? { id: user.id, email: user.username, avatar: user.avatar }
      : { id: '', email: '', avatar: '' };
  };

  return {
    loginSubject,
    systemReadySubject,
    sessionStatusSubject,
    watchLogin,
    watchSystemReady,
    watchSessionStatus,
    getLoggedInUser,
  };
}
